import { render, staticRenderFns } from "./IBuzzPen.vue?vue&type=template&id=7e535a26&scoped=true"
import script from "./IBuzzPen.vue?vue&type=script&lang=js"
export * from "./IBuzzPen.vue?vue&type=script&lang=js"
import style0 from "./IBuzzPen.vue?vue&type=style&index=0&id=7e535a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e535a26",
  null
  
)

export default component.exports